import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Router} from 'react-router-dom';

import AppLoadeRaw from '../../components/Loader/AppLoader/AppLoadeRaw';
import appConfig from '../../config/appConfig';
import useLayoutChange from '../../hooks/useLayoutChange';
import analyticsService from '../../services/analyticsService';
import appService from '../../services/app/appService';
import history from '../../services/history';
import log from '../../services/logger/log';
import userBrowserService from '../../services/user/userBrowserService';
import userDeviceService from '../../services/user/userDeviceService';
import {hideLoader, setIsAppLoaded} from '../../state/ducks/global';
import {selectIsAppLoading} from '../../state/selectors/global';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import Routes from '../Routes/Routes';
import useSetNavigationTarget from './hooks/navigationTarget/useSetNavigationTarget';
import useDisableOfflineDetector from './hooks/useDisableOfflineDetector';

const App = () => {
    const isAppLoading = useSelector(selectIsAppLoading);
    const dispatch = useDispatch();

    const onInit = async () => {
        const isBleSupported = userDeviceService.isBluetoothSupported();
        const isBluefyBrowser = userBrowserService.isBluefyBrowser();

        if (process.env.REACT_APP_IS_BUILD_REF === 'true') {
            await appService.initializeStartActions();
        } else {
            if (appConfig.getIsMarketInitialized()) {
                await appService.initializeStartActions();
            } else {
                await appService.initializeUserSessionActions();
            }
        }

        analyticsService.pushAppLoadedEvent();
        analyticsService.pushBrowserCompatibilityEvent(isBleSupported, isBluefyBrowser);

        dispatch(setIsAppLoaded());

        log.info(`App: app is started successfully, isBleSupported: ${isBleSupported}`);

        if (!isBleSupported) {
            dispatch(hideLoader());
        }
    };

    useEffect(() => {
        onInit();
    }, []);

    useDisableOfflineDetector();
    useSetNavigationTarget();

    return (
        <ErrorBoundary>
            <LayoutChangeListener />
            {isAppLoading ? (
                <AppLoadeRaw />
            ) : (
                <Router history={history.getHistory()}>
                    <Routes />
                </Router>
            )}
        </ErrorBoundary>
    );
};

export default App;

const LayoutChangeListener = () => {
    useLayoutChange();
};
